import { ApiService } from '~/services/api/api'
import type { UserPin } from '~/types/UserPin'

export class UserPinsService {
  private readonly apiService = new ApiService()

  async getUserPins(userId: string) {
    const response = await this.apiService.get<UserPin[]>(
      `/users/${userId}/pins`,
    )
    return response
  }

  async deleteUserPin(userId: string, pinId: string) {
    const response = await this.apiService.delete<UserPin>(
      `/users/${userId}/pins/${pinId}`,
    )
    return response
  }

  async postUserPin(userId: string, pin: Partial<UserPin>) {
    const response = await this.apiService.post<UserPin>(
      `/users/${userId}/pins`,
      pin,
    )
    return response
  }
}
